import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboLotesActivo`, method: 'GET', body: null, token: token})
}